import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@core-engine/config/types.js'
import { safeWriteFile } from '@core-engine/utils/fs.js'
import {
  applyAdminNamespaceToContent,
  applyAdminNamespaceToPath
} from '@next-adapter/config/namespace.js'
import { readTemplate } from '@next-adapter/template-reader.js'

export interface AuthScaffoldOptions {
  cwd: string
  config: ResolvedBetterstartConfig
}

export function scaffoldAuth({ cwd, config }: AuthScaffoldOptions): string[] {
  const created: string[] = []
  const authDir = path.resolve(cwd, config.paths.admin, 'lib', 'actions', 'auth')
  const namespace = config.frameworkConfig.next.namespace

  function write(filename: string, content: string): void {
    const outputFile = applyAdminNamespaceToPath(filename, namespace)
    const fullPath = path.join(authDir, outputFile)
    if (safeWriteFile(fullPath, applyAdminNamespaceToContent(content, namespace))) {
      created.push(path.join(config.paths.admin, 'lib', 'actions', 'auth', outputFile))
    }
  }

  write('server.ts', readTemplate('lib/actions/auth/auth.ts'))
  write('client.ts', readTemplate('lib/actions/auth/client.ts'))
  write('session.ts', readTemplate('lib/actions/auth/middleware.ts'))

  return created
}
